import style from './index.module.scss';
import { ReactComponent as BurgerSvg } from '../../assets/icons/burger.svg';
import clsx from 'clsx';

function Burger({ open }) {
    return <BurgerSvg className={clsx(style.burger, open && style.active)} />;
}

export default Burger;
